import axios from 'axios';
import {
    PatientPortalData,
    PatientPortalDataListResult,
    PatientPortalDataType
} from '../models/patient-portal-data';

export const getPatientPortalDatas = async (type: Undefinable<PatientPortalDataType>): Promise<Undefinable<PatientPortalData[]>> => {
    const response = await axios.get(`/api/patient-portal-data/type${type ? `/${type}` : ''}`);
    return response.data;
};

export const createPatientPortalData = async (patientPortalData: MixType<PatientPortalData>): Promise<PatientPortalDataListResult> => {
    const data = Array.isArray(patientPortalData) ? patientPortalData : [patientPortalData];
    const response = await axios.post(`/api/patient-portal-data`, data);
    return response.data;
};
